<template>
  <div class="gift" v-cloak>
    <!-- 礼物弹窗 -->
    <div class="gift_window vux-1px-t" v-show="closeGiftBox" @click.stop>
      <div class="gift_container_one">
        <div v-for="(item, index) in giftList" :key="index" class="gift_list">
          <img :src="item.icon" alt="" />
          <div class="gift_name">{{ item.name }}</div>
          <div class="gift_needTime">
            {{ item.score == 0 ? '免费' : item.score + '积分' }}
          </div>
          <div class="gift_exchange" @click.stop="exChange(item)">赠送</div>
        </div>
      </div>
      <!-- <div class="gift_container_two">
                <div class="lecture_time_long">
                听课时长:
                <span>{{lectureTime}}分钟</span>
                </div>
                <div>(双击礼物图标可直接兑换全部时长)</div>
            </div> -->
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { setInterval, clearInterval } from 'timers';
import { live } from '@/api/ajax.js';
export default {
  name: '',
  props: {
    showGiftWindow: {
      type: Number,
      default: false
    },
    detailObj: Object
  },
  data() {
    return {
      // 测试数据
      giftList: [],
      closeWindow: false,
      lectureTime: 0,
      giftTime: 1,
      timePlus: null,
      giftType: 1
    };
  },
  methods: {
    ...mapMutations(['CLOSEGIFTBOX', 'SET_INTEGRAL']),
    // 听课时长
    lectureTimeLong() {
      let time = this.$api.getStorage(this.$route.params.id);
      if (this.$api.getStorage(this.$route.params.id) == 1) {
        this.lectureTime = 0;
      } else {
        this.lectureTime = parseInt(time / 60);
        let time1 = setInterval(() => {
          let time = this.$api.getStorage(this.$route.params.id);
          this.lectureTime = parseInt(time / 60);
        }, 60 * 1000);
      }
    },
    // 按钮兑换
    exChange(data) {
      //兑换礼物
      if (data.score <= this.wxUserInfo.userIntegral) {
        //积分充足的情况
        this.SET_INTEGRAL(this.wxUserInfo.userIntegral - data.score);
        var data2 = {
          type: 2,
          userName: this.wxUserInfo.nickName || '',
          userId: this.wxUserInfo.id || '',
          userClickTime: new Date().getTime(),
          courseId: this.$route.params.id,
          giftType: data.giftType,
          giftCount: 1,
          giftImg: data.icon,
          giftName: data.name,
          liveEndTime: this.detailObj.liveEndTime
        };
        // window.dmsocket.send(JSON.stringify(data2))
        live
          .sendGift({
            giftName: data.name,
            type: data.giftType,
            courseId: this.$route.params.id,
            giftNum: 1
          })
          .then(() => {
            this.CLOSEGIFTBOX(false);
          });
        // 送礼物埋点
        this.$sa.re_interaction({
          type: '送花' + data.giftType, // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
          contentype: 5, // 互动主体 直播，录播，资讯，病例，站内信，论坛
          contentid: this.$route.params.id, // 内容id
          first_cate: this.categoriesList[0].categoryName, //一级分类
          second_cate: this.categoriesList[1].categoryName, // 2级分类
          first_cate_id: this.categoriesList[0].id, // 1级分类id
          second_cate_id: this.categoriesList[1].id, //2级分类id
          author: this.detailObj.editor || '', //讲师/作者
          contentname: this.detailObj.courseName
          // location:'', //位置 站内，专区内，超级面对面内
        });
      } else {
        this.$vux.toast.show({
          text: '您的积分不足',
          type: 'text',
          position: 'middle',
          width: '6rem'
        });
      }
    },
    // 进入页面看视频计时
    inPageLectureCourse() {
      if (!this.$api.getStorage(this.$route.params.id)) {
        this.giftTime = 1;
        this.$api.setStorage(this.$route.params.id, this.giftTime);
      } else {
        this.giftTime = this.$api.getStorage(this.$route.params.id);
      }
      this.time = setInterval(() => {
        this.giftTime += 5;
        this.$api.setStorage(this.$route.params.id, this.giftTime);
        this.lectureTime = parseInt(this.giftTime / 60);
      }, 5000);
    }
  },
  watch: {
    lectureTime: function(v) {
      this.lectureTime = v;
      this.$emit('lectrueLength', v);
    },
    showGiftWindow: function(v) {
      if (this.showGiftWindow) {
        this.giftTime = 1;
        this.$api.setStorage(this.$route.params.id, this.giftTime);
        this.lectureTime = 0;
        //this.lectureTimeLong();
      }
    },
    giftTime: function(v) {
      if (new Date().getTime() >= this.detailObj.liveEndTime) {
        this.giftTime = 1;
        sessionStorage.removeItem(this.$route.params.id);
        clearInterval(this.time);
      }
    }
  },
  computed: {
    ...mapState({
      closeGiftBox: state => state.closeGiftBox,
      categoriesList: state => state.categoriesList,
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {},
  created() {
    this.inPageLectureCourse();
    this.lectureTimeLong();
    live.getGiftList().then(res => {
      this.giftList = res.data.data;
    });
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearInterval(this.time);
  }
};
</script>
<style lang="less" scoped>
.gift_window {
  position: fixed;
  left: 0;
  bottom: -5.07rem;
  width: 100vw;
  height: 5.07rem;
  background: #fff;
  box-shadow: 0 -1px 7px 0 rgba(0, 0, 0, 0.06);
  z-index: 8012;
  animation: giftgotop 0.5s linear;
  -webkit-animation: giftgotop 0.5s linear;
  animation-fill-mode: forwards;

  .gift_container_one {
    // 兼容横屏
    display: flex;
    max-width: 10.85rem;
    height: 3.65rem;
    .gift_list {
      padding-top: 0.53rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 25%;
      img {
        width: 1.47rem;
        height: 1.47rem;
      }
      .gift_name {
        color: #191919;
        font-size: 0.37rem;
      }
      .gift_needTime {
        color: #999;
        font-size: 0.32rem;
      }
      .gift_exchange {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.35rem;
        color: #fff;
        width: 1.28rem;
        height: 0.61rem;
        line-height: 0.61rem;
        border: 1px solid #027cfa;
        border-radius: 0.13rem;
        background: #3699ff;
      }
    }
  }
  .gift_container_two {
    max-width: 10.85rem;
    padding: 0 0.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1.41rem;
    div:nth-of-type(1) {
      font-size: 0.32rem;
      span {
        padding-left: 0.2rem;
        color: #027cfa;
      }
    }
    div:nth-of-type(2) {
      font-size: 0.32rem;
      color: #999;
    }
  }
}
.lecture_fail {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 6.43rem;
  height: 1.33rem;
  text-align: center;
  line-height: 1.33rem;
  font-size: 0.4rem;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 0.11rem;
  transform: translate(-50%, -50%);
  z-index: 999;
}
@-webkit-keyframes giftgotop {
  0% {
    bottom: -5.07rem;
    opacity: 1;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
</style>
